import React from 'react';

import Icon, { IconName } from '~/components/Icon';
import { cn } from '~/utils/cn';

interface SocialLink {
  name: string;
  icon: IconName;
  href: string;
}

const socialLinks: SocialLink[] = [
  {
    name: 'TikTok',
    icon: 'tiktok',
    href: 'https://www.tiktok.com/@respawww_n'
  },
  {
    name: 'YouTube',
    icon: 'youtube',
    href: 'https://www.youtube.com/@respawww_n'
  },
  {
    name: 'Instagram',
    icon: 'instagram',
    href: 'https://www.instagram.com/respawwwn'
  },
  { name: 'Discord', icon: 'discord', href: 'https://discord.gg/49tS4mVNbp' },
  { name: 'Kofi', icon: 'kofi', href: 'https://ko-fi.com/respawwwn' }
];

function SocialLinks({ className }: { className?: string }) {
  return (
    <ul className={cn('flex w-fit items-center gap-5', className)}>
      {socialLinks.map(({ name, icon, href }) => (
        <li key={name}>
          <a
            href={href}
            target="_blank"
            rel="noreferrer noopener"
            aria-label={name}
            data-cy={`${name}-social-link`}
            className="block transition-transform duration-150 hover:-translate-y-0.5 focus-visible:-translate-y-0.5"
          >
            <Icon name={icon} size={6} />
          </a>
        </li>
      ))}
    </ul>
  );
}

export default SocialLinks;
